module.exports = __webpack_public_path__ + "static/HOME_PARTNERS-MICROSOFT-WANCLOUDS.316793f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HOME_PARTNERS-MICROSOFT-WANCLOUDS.png
// module id = 514
// module chunks = 35783957827783